import {
  TextField as TextFieldMui,
  TextFieldProps as TextFieldMuiProps,
  SxProps,
  Theme,
} from "@mui/material";
import React, { forwardRef } from "react";

import { ColorType } from "types";

import { InputFieldWrapper } from "./input-field-wrapper";

import { COLORS } from "../consts";

export type TextFieldProps = TextFieldMuiProps & { message?: any, sxLabel?: SxProps<Theme>, sx?: SxProps<Theme> | undefined };

export interface TextFieldColorState {
  color?: ColorType;
  message?: any;
  sxLabel?: SxProps<Theme>;
}

export const TextField: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<TextFieldProps> & React.RefAttributes<HTMLDivElement>
> = forwardRef(({ label, message, color, style, sxLabel, sx, required, ...props }, ref) => (
  <InputFieldWrapper label={label} color={color} message={message} sxLabel={sxLabel} required={required}>
    <TextFieldMui
      hiddenLabel
      size="small"
      sx={{
        ".MuiInputBase-root.Mui-disabled": {
          backgroundColor: COLORS.disabled,
        },
        ".MuiInputBase-input": {
          ...style,
        },
        ...sx,
      }}
      color={color}
      focused={!!color}
      {...props}
      ref={ref}
    />
  </InputFieldWrapper>
),
);